import { render, staticRenderFns } from "./title1.vue?vue&type=template&id=fadc6eaa&scoped=true"
import script from "./title1.vue?vue&type=script&lang=js"
export * from "./title1.vue?vue&type=script&lang=js"
import style0 from "./title1.vue?vue&type=style&index=0&id=fadc6eaa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadc6eaa",
  null
  
)

export default component.exports